import { CoralogixRum } from "@coralogix/browser";

let initialized = false;

/**
 * Initialize Coralogix Real User Monitoring (browser SDK).
 * Safe to call multiple times; runs once.
 *
 * Set at build time (Create React App):
 * - REACT_APP_CORALOGIX_RUM_PUBLIC_KEY — RUM public key from Coralogix (RUM Integration Package), not the server DataPrime key
 * - REACT_APP_CORALOGIX_DOMAIN — account domain label, e.g. EU2, US1, AP1 (see Coralogix account settings)
 * Optional:
 * - REACT_APP_CORALOGIX_APPLICATION (default zuug-landing-page)
 * - REACT_APP_CORALOGIX_ENVIRONMENT (default production)
 * - REACT_APP_APP_VERSION (default package version from env at build)
 */
export function initCoralogixRum() {
	if (initialized) {
		return;
	}
	const publicKey = process.env.REACT_APP_CORALOGIX_RUM_PUBLIC_KEY || "";
	const domain = process.env.REACT_APP_CORALOGIX_DOMAIN || "";
	if (!publicKey || !domain) {
		if (process.env.NODE_ENV === "development") {
			// eslint-disable-next-line no-console
			console.info(
				"[zuug-landing] Coralogix RUM disabled: set REACT_APP_CORALOGIX_RUM_PUBLIC_KEY and REACT_APP_CORALOGIX_DOMAIN for production builds."
			);
		}
		return;
	}
	try {
		CoralogixRum.init({
			public_key: publicKey,
			coralogixDomain: domain,
			application: process.env.REACT_APP_CORALOGIX_APPLICATION || "zuug-landing-page",
			version: process.env.REACT_APP_APP_VERSION || "0.1.0",
			environment: process.env.REACT_APP_CORALOGIX_ENVIRONMENT || "production",
			stringifyCustomLogData: true,
			labels: {
				subsystem: "zuug-landing-page",
			},
			sessionConfig: {
				sessionSampleRate: Number(
					process.env.REACT_APP_CORALOGIX_SESSION_SAMPLE_RATE || 100
				),
				excludeFromSampling: ["custom"],
			},
			instrumentations: {
				errors: true,
				fetch: true,
				xhr: true,
				custom: true,
			},
		});
		initialized = true;
	} catch (e) {
		// eslint-disable-next-line no-console
		console.warn("[zuug-landing] Coralogix RUM init failed:", e);
	}
}
